var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('van-swipe',{staticClass:"banner-swipe",attrs:{"autoplay":5000,"indicator-color":"white"}},[_vm._l((_vm.templeImgArr),function(item,index){return [_c('van-swipe-item',{key:index},[_c('van-image',{staticClass:"bless-img-img svg-icon-img",attrs:{"fit":"fill","src":`${item}`}})],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }